// A one-shot signal between a context menu item and the control pane. Hiding
// an element at the current breakpoint closes the menu and selects the closest
// parent; the control pane consumes the request once the pane for that parent
// is rendered and reopens the "more" menu for it.
let isRequested = false;

export const requestContextMenuReopen = () => {
  isRequested = true;
};

export const isContextMenuReopenRequested = () => isRequested;

export const consumeContextMenuReopenRequest = () => {
  const wasRequested = isRequested;
  isRequested = false;
  return wasRequested;
};
